import React from 'react';
import { fx } from '../../fx.js';
import { MONO } from '../../primitives.js';

const h = React.createElement;

const HEX = '0123456789abcdef';

/**
 * Machine text that resolves through hex noise, left to right. Separators never scramble; the real
 * text is the accessible name.
 *
 * @param {object} p
 * @param {string} p.text
 * @param {'mount'|'hover'|'both'} [p.on]
 * @param {number} [p.duration]
 * @param {React.CSSProperties} [p.style]
 */
export function Scramble({ text, on = 'mount', duration = 420, style }) {
  const [out, setOut] = React.useState(() => text);
  const raf = React.useRef(0);
  const run = React.useCallback(() => {
    if (fx.reduced && fx.reduced()) return;
    cancelAnimationFrame(raf.current);
    const t0 = performance.now(), chars = Array.from(text);
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / duration), fixed = Math.floor(k * chars.length);
      setOut(chars.map((c, i) => (i < fixed || /[\s_.@:/-]/.test(c) ? c : HEX[(Math.random() * 16) | 0])).join(''));
      if (k < 1) raf.current = requestAnimationFrame(tick); else setOut(text);
    };
    raf.current = requestAnimationFrame(tick);
  }, [text, duration]);
  React.useEffect(() => { if (on === 'mount' || on === 'both') run(); else setOut(text); return () => cancelAnimationFrame(raf.current); }, [text]);
  return h('span', { 'aria-label': text, onPointerEnter: on === 'hover' || on === 'both' ? run : undefined, style: { fontFamily: MONO, whiteSpace: 'pre', ...style } },
    h('span', { 'aria-hidden': true }, out));
}
